import { render } from "./HeroiconsOutlineBell.vue?vue&type=template&id=7eba22df"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBell.vue"]])

export default __exports__